import * as React from 'react';
import { Modal } from 'reactstrap';
import { css } from '@emotion/css';
import i18next from 'i18next';
import { qlearnUrl } from '.';

interface LoginNavigationModalProp {
  show: boolean;
}

const styles = {
  content: css`
    box-shadow: 0 1px 4px 0 rgb(0 0 0 / 15%);
    border: none;
    margin-top: 10px;
  `,
  button: css`
    width: 160px;
    &:focus {
      outline: none;
    }
  `,
  modalDialog: css`
    margin-top: 10px;
  `,
};

const LoginNavigationModal: React.FC<LoginNavigationModalProp> = ({
  show,
}: LoginNavigationModalProp) => {
  const [open, setOpen] = React.useState<boolean>(false);

  const onClickCancelButton = () => {
    setOpen(false);
  };

  const onClickGoBackToLoginButton = () => {
    window.location.href = `${qlearnUrl}/ja/login`;
  };

  React.useEffect(() => {
    if (show) {
      setOpen(show);
    }
  }, [show]);

  return (
    <Modal
      isOpen={open}
      autoFocus={true}
      className={styles.modalDialog}
      modalClassName={open ? 'in' : ''}
      backdropClassName={open ? 'in' : ''}
      contentClassName={styles.content}
      returnFocusAfterClose={true}
    >
      <div className="area p-y-lg xs-down-p-x-md sm-up-p-x-lg">
        <div className="size-lg bold text-center m-b-lg">
          <div>
            {i18next.t('registration.sign_up.new.login_navigation_modal.title')}
          </div>
        </div>
        {i18next.t('registration.sign_up.new.login_navigation_modal.body')}
        <p />
        <div className="row text-center">
          <div className="col-sm-6 col-sm-push-6 col-xs-12 sm-up-text-left xs-down-m-b-lg">
            <button
              className={`btn btn-primary double-btn basic-or-coaching-apply ${styles.button}`}
              onClick={onClickGoBackToLoginButton}
            >
              {i18next.t(
                'registration.sign_up.new.login_navigation_modal.go_back_to_login',
              )}
            </button>
          </div>
          <div className="col-sm-6 col-sm-pull-6 col-xs-12 sm-up-text-right">
            <button
              className={`btn btn-secondary double-btn basic-or-coaching-apply ${styles.button}`}
              onClick={onClickCancelButton}
            >
              {i18next.t(
                'registration.sign_up.new.login_navigation_modal.cancel',
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(LoginNavigationModal);
